<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink="../">
        Budżet obywatelski
      </a>
    </li>
    <li>
      @if (loading()) {
        Ładowanie...
      } @else {
        {{ budget()?.name }}
      }
    </li>
  </app-breadcrumbs>
  <section>
    @if (!!alertContainerComponent?.alertService?.alerts()?.length) {
      <br>
    }
    <app-alert-container #alertContainerComponent [dismissible]='true'></app-alert-container>
    @if (loading()) {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    } @else {
      <h2>
        {{ budget()?.name }}
      </h2>
      @if (!authed) {
        <app-alert [closable]="false" alertTitle="Uwaga!">
          Zgłaszać projekty mogą wyłącznie zalogowani użytkownicy. <a routerLink='/goto-login-gov'>
          <strong>
            Zaloguj się aby zgłosić projekt
          </strong>
        </a>
        </app-alert>
      }
      <div class="gov-card">
        <div class="gov-card__header d-flex justify-content-between align-items-center">
          {{ budget()?.description || '-' }} @if ((budget()?.stage === 'project_submission') && (budget()?.status === 'active') && authed) {
          <a class="btn btn-secondary" routerLink="zglos">Zgłoś projekt</a>
        }
        </div>
        <div class="gov-card__body">
          <div class="row">
            <div class="col-12">
              <app-label label="Aktualny etap:">
                Zgłaszanie projektów
              </app-label>
            </div>
            <div class="col-12">
              <div class="editor-content">
                <br>
                <p><strong>Harmonogram:</strong></p>
                <ul>
                  <li>
                    Kampania informacyjna 1.11.225 - 30.11.2025
                  </li>
                  <li>
                    Weryfikacja zgłoszonych projektów 1.01.2026 - 14.01.2026
                  </li>
                  <li>
                    Prezentacja projektów 15.01.2026 10:00
                  </li>
                  <li>
                    Głosowanie 16.01.2026 - 31.01.2026
                  </li>
                  <li>
                    Ogłoszenie wyników - 1.02.2026 10:00
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </section>
</app-content>
